import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2192">
      <About data-id="element-2193" />
    </main>;
}